import { BUSINESS_HOURS_PER_DAY } from "@forgepoint/shared";

const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_BUSINESS_DAY = BUSINESS_HOURS_PER_DAY * SECONDS_PER_HOUR;

/**
 * Formats a business-time duration in business hours, or business days once it
 * reaches a full business day.
 * @param seconds - Business seconds, or null when not available
 * @returns A compact value such as "6.5h" or "2.3d", or "--" for null
 */
export function formatBusinessDuration(seconds: number | null): string {
  if (seconds === null) {
    return "--";
  }
  if (seconds < SECONDS_PER_BUSINESS_DAY) {
    return `${(seconds / SECONDS_PER_HOUR).toFixed(1)}h`;
  }
  return `${(seconds / SECONDS_PER_BUSINESS_DAY).toFixed(1)}d`;
}
